import { render, staticRenderFns } from "./SecondaryPillButton.vue?vue&type=template&id=31161e06&scoped=true"
import script from "./SecondaryPillButton.vue?vue&type=script&lang=js"
export * from "./SecondaryPillButton.vue?vue&type=script&lang=js"
import style0 from "./SecondaryPillButton.vue?vue&type=style&index=0&id=31161e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31161e06",
  null
  
)

export default component.exports